import React from "react";
import { observer } from "mobx-react-lite";
import { Text, Stack, Button } from "@chakra-ui/react";
import { CraAttributes } from "@keita/lanepatrol-sdk";
import { CraAttributeUtils } from "../../../../../../coding/utils/attribute-utils";
import { CustomDialog } from "../../../../../../shared/views/CustomDialog";

interface Props {
  onClose: () => void;
  label?: string;
  infoText?: string;
}

const AttributeInfoModalBase: React.FC<Props> = ({
  onClose,
  label,
  infoText,
}) => {
  const isSingleAttribute = !!label;

  return (
    <CustomDialog
      size="lg"
      header={isSingleAttribute ? label : "Attribute information"}
      footer={
        <Button colorPalette="primary" onClick={onClose}>
          Close
        </Button>
      }
      onClose={onClose}
    >
      {isSingleAttribute ? (
        <Text
          fontSize="sm"
          lineHeight="1.5"
          dangerouslySetInnerHTML={{ __html: infoText ?? "" }}
        />
      ) : (
        <Stack gap={8} maxH="70vh" overflowY="auto">
          {CraAttributes.all.map((attribute) => {
            const info = CraAttributeUtils.getInfo(attribute.name);

            if (!info) return null;

            return (
              <Stack
                key={attribute.name}
                gap={2}
                borderLeft="1px solid"
                borderColor="gray.200"
                pl={4}
              >
                <Text fontWeight="bold" fontSize="md">
                  {CraAttributeUtils.getLabel(attribute.name)}
                </Text>

                <Text
                  fontSize="sm"
                  lineHeight="1.5"
                  dangerouslySetInnerHTML={{ __html: info }}
                />
              </Stack>
            );
          })}
        </Stack>
      )}
    </CustomDialog>
  );
};

export const AttributeInfoModal = observer(AttributeInfoModalBase);
